/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询云剧院视频分类
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cloundtheater.VideoCategoryDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cloundtheater/category`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
